<template>
    <div class="rules">
        <div class="close cursor" @click="closeRulesModel"></div>
        <div class="cnt"></div>
    </div>
</template>
<script>
export default {
    methods: {
        closeRulesModel() {
            this.$emit('rulesModelClose', false, 2)
        }
    }
}
</script>
<style lang="scss" scoped>
.rules {
    background: url("../../../assets/img/common/model-bg.png") no-repeat top;
    background-size: 100% 100%;
    width: 716px;
    height: 339px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .close {
        background: url("../../../assets/img/common/close.png") no-repeat top;
        background-size: 100% 100%;
        width: 56px;
        height: 49px;
        position: absolute;
        right: 0;
        top: -49px;

    }

    .cnt {
        background: url("../../../assets/img/m4/lottery/rule/rule.png") no-repeat top;
        background-size: 100% 100%;
        width: 582px;
        height: 182px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/eventComponents/rules.vue